import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination } from 'swiper/core'

Swiper.use([Navigation, Pagination])

export default class extends Controller {
  static targets = ['swiper', 'prevBtn', 'nextBtn', 'pagination']

  get className () {
    return this.element.dataset.classname || ''
  }

  connect () {
    if (!this.hasSwiperTarget) return

    try {
      this.swiper = new Swiper(this.swiperTarget, {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 16,
        autoHeight: true,
        navigation: {
          nextEl: this.hasNextBtnTarget ? this.nextBtnTarget : null,
          prevEl: this.hasPrevBtnTarget ? this.prevBtnTarget : null,
        },
        pagination: {
          el: this.hasPaginationTarget ? this.paginationTarget : null,
          clickable: true,
          bulletActiveClass: `${this.className}::active`,
        },
      })
    } catch (error) {
      console.error('[Campaign Swiper] 初期化に失敗しました:', error)
    }
  }

  disconnect () {
    this.swiper?.destroy()
  }

  toggleCard (event) {
    const card = event.currentTarget.closest('[data-classname]')
    if (!card) return
    card.classList.toggle(`${card.dataset.classname}::card--open`)
    this.swiper?.update()
  }
}
